import React from 'react';
import { Modal } from 'antd';
import { useHistory } from 'react-router-dom';

import { CashboxForm } from '../containers/form';
import { localURLMaker } from '../../../../shared/utils/url-maker';

export const UpdateCashboxPage = () => {
  const history = useHistory();

  return (
    <Modal visible={true} width={576} footer={null} title='Kassada düzəliş et' onCancel={() => history.push('/cash-flow/cashboxes')}>
      <CashboxForm type='update' redirectUrl={localURLMaker('/cash-flow/cashboxes', {}, { reFetchCashboxesTable: true })} />
    </Modal>
  );
};
